import { render, staticRenderFns } from "./balanceDoc.vue?vue&type=template&id=cb157036&"
import script from "./balanceDoc.vue?vue&type=script&lang=js&"
export * from "./balanceDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports